import * as React from 'react';
import { cn } from '@/lib/utils';

const ProgressWrapper = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-progress-wrapper',
      // styles
      'relative h-4 overflow-hidden rounded bg-bright',
      className
    )}
    {...props}
  />
));
ProgressWrapper.displayName = 'ProgressWrapper';

const ProgressBar = React.forwardRef(({ className, valueNow = 0, ...props }, ref) => (
  <div
    ref={ref}
    role="progressbar"
    style={{ width: `${valueNow}%` }}
    aria-valuenow={valueNow}
    aria-valuemin="0"
    aria-valuemax="100"
    className={cn(
      'c-progress-bar',
      // styles
      'z-9 absolute inset-0 bg-secondary',
      className
    )}
    {...props}
  />
));
ProgressBar.displayName = 'ProgressBar';

const ProgressText = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-progress-text',
      // styles
      'absolute z-10 h-full pl-2.5 text-left text-xs font-bold leading-4 text-neutral-dark',
      className
    )}
    {...props}
  />
));
ProgressText.displayName = 'ProgressText';

export function Progress(props) {
  const { valueNow = 0, showText } = props;

  return (
    <ProgressWrapper>
      <ProgressBar valueNow={valueNow} />
      {showText && <ProgressText>{valueNow}%</ProgressText>}
    </ProgressWrapper>
  );
}
